import { BoxProps, HighlightsCollectionProps } from './types';
import { FC, memo } from 'react';

import { PunchupStatTileGrid } from 'features/common/components/Punchup/primitives/display/PunchupTile';
import { PunchupHighlightCard } from './PunchupHighlightCard';

const PunchupHighlightsCollection = ({ boxCollection, children }: HighlightsCollectionProps) => (
	<PunchupStatTileGrid>
		{boxCollection.map(({ ...props }: BoxProps) => (
			<PunchupHighlightCard key={props.property} {...props} />
		))}
		{children}
	</PunchupStatTileGrid>
);

const memorizedHighlightsCollection: FC<HighlightsCollectionProps> = memo(PunchupHighlightsCollection);

export { memorizedHighlightsCollection as PunchupHighlightsCollection };
